import { MSAViewer } from './msa-viewer';

/**
 * Setters for MSAViewer properties
 */
export class MSAViewerSetters {
  
  static setApiEndpoint(instance: MSAViewer, value: string | undefined): void {
    instance._apiEndpoint = value;
    instance.updateApiUrl();
  }
  
  static setIdentifier(instance: MSAViewer, value: string | undefined): void {
    instance._identifier = value;
    instance.updateApiUrl();
  }

  static setHeight(instance: MSAViewer, value: number): void {
    instance._height = value;
    instance.updateTrackConfig({ height: value });
  }

  static setWidth(instance: MSAViewer, value: number): void {
    instance._width = value;
    instance.updateTrackConfig({ width: value });
  }

  static setLabelWidth(instance: MSAViewer, value: number): void {
    instance._labelWidth = value;
    instance.updateTrackConfig({ labelWidth: value });
  }

}